import React from 'react'
import { Link } from 'react-router-dom'

import useBreakPoint from 'CustomHook/useBreakPoint'
import { LanguageSelector } from '@Core/Components/Nav/'
import RootZoom from '@Core/Components/RootZoom'

import companyLogo from '@Assets/nada_logo_revised_logo.png'
import ashokStambh from '@Assets/ashok_stambh.png'
import ashokStambhG20 from '@Assets/ashok_stambh_g20.png'
import { HeaderLeftPannal, HeaderWrapper, TitleWrapper } from './style'

const Header = () => {
  const { xs, sm, md, lg } = useBreakPoint()
  return (
    <HeaderWrapper
      padding={xs ? '.3rem .3rem' : sm ? '1rem 3rem' : '1rem 5rem'}
    >
      <div>
        <Link to={'/'}>
          <div className="iconWrapper">
            <img
              className="width5rem"
              src={ashokStambh}
              alt="ashok_stambh_logo"
            />
            <img className="width5rem" src={companyLogo} alt="company_logo" />
          </div>
        </Link>
      </div>
      {(md || lg) && (
        <TitleWrapper>
          <h1>Know Your Medicine</h1>
        </TitleWrapper>
      )}
      <HeaderLeftPannal>
        {!xs && (
          <div className="iconWrapper">
            <img
              className="img1_azadi_year_logo"
              src={ashokStambhG20}
              alt="azadi_year_logo"
            />
          </div>
        )}
        <LanguageSelector />
        <RootZoom />
      </HeaderLeftPannal>
    </HeaderWrapper>
  )
}

export default Header
